import type { IconData } from '@stacksjs/iconify-core'

export const commentAltDots: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19 2H5a3.003 3.003 0 0 0-3 3v10a3.003 3.003 0 0 0 3 3h11.586l3.707 3.707A1 1 0 0 0 22 21V5a3.003 3.003 0 0 0-3-3M8 11a1 1 0 1 1 1-1a1 1 0 0 1-1 1m4 0a1 1 0 1 1 1-1a1 1 0 0 1-1 1m4 0a1 1 0 1 1 1-1a1 1 0 0 1-1 1\" opacity=\".5\"/><circle cx=\"8\" cy=\"10\" r=\"1\" fill=\"currentColor\"/><circle cx=\"12\" cy=\"10\" r=\"1\" fill=\"currentColor\"/><circle cx=\"16\" cy=\"10\" r=\"1\" fill=\"currentColor\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default commentAltDots
